define(['underscore',
        'text!./templates/question-set.html'],
    (_, templateStr) => {

        return function () {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    baslerQuestionSet: '=',
                    baslerQuestionSetConfig: '=',
                    baslerQuestionsetLookandfeel: '=',
                },
                link: function ($scope, element) {
                    if (!$scope.baslerQuestionsetLookandfeel) {
                        element[0].className += ' no-questionset-style';
                    }
                },
                controller: ['$scope', 'QuestionSetService', 'BaslerQuestionSetService',
                    function ($scope, QuestionSetService, BaslerQuestionSetService) {
                        $scope.questionSets = QuestionSetService.getQuestionSetViewModel($scope.baslerQuestionSet);

                        //It doesn't modify existing OOTB behaviour, but just adds new aspect attributes: baslerAvailable,
                        // baslerReadonly and resets answers if configured
                        BaslerQuestionSetService.createQuestionSetViewModelAddons($scope.baslerQuestionSetConfig, $scope.questionSets);
                    }],
            };
        };
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/baslerquestionsets/QuestionSetDirective.js